export default "__VITE_ASSET__QUD$p_a8__"